import { render, staticRenderFns } from "./TemplateOverview.vue?vue&type=template&id=5b466d7c&lang=pug&"
import script from "./TemplateOverview.vue?vue&type=script&lang=js&"
export * from "./TemplateOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports